import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Content from "../common/template/content";
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_dark from "@amcharts/amcharts4/themes/dark.js";
import { DisplayPDF } from "../displayPDF/displayPDF";
import { AnaliseCusto } from "./abas/AnaliseCusto.jsx";
import { AnaliseConsumo } from "./abas/AnaliseConsumo.jsx";
import { AnaliseTarifa } from "./abas/AnaliseTarifa.jsx";
import { AnaliseDemanda } from "./abas/AnaliseDemanda.jsx";
import { AnaliseReativo } from "./abas/AnaliseReativo.jsx";
import { AnaliseMulta } from "./abas/AnaliseMulta.jsx";
import { AnaliseGestaoEmpenho } from "./abas/AnaliseGestaoEmpenho.jsx";
import { AnaliseMicroMiniGeracao } from "./abas/AnaliseMicroMiniGeracao.jsx";
import { AnaliseDevolucaoRessarcimento } from "./abas/AnaliseDevolucaoRessarcimento.jsx";
import { AnaliseAproveitamentoConsumoHorario } from "./abas/AnaliseAproveitamentoConsumoHorario.jsx";
import {
    setFiltro,
    getListaCliente,
    getListaUnidadeConsumidora,
    getListaDemandaContratoTipo,
    getListaAnosEmpenho,
    setTabSelecionada,
    getListaGraficoCustoAnual,
    getListaGraficoConsumoAnual,
    getListaGraficoValorDevolvidoAnual,
    getListaGraficoCustoMultaAnual,
    getListaGraficoCustoReativoAnual,
    getListaGraficoConsumoForaPonta,
    getListaAnaliseCativoMercadoLivreMensal,
    getListaContratosAluguelHistorico,
    getListaGeradorasContratosAluguelHistorico,
} from "./analiseActions";
import { Abas } from "./components/Abas.jsx";
import { Loading } from "../common/loading/loading";
import { setError, setInfo } from "../common/toast/toast.jsx";
import { setArquivoPDF } from "../displayPDF/displayPDFActions";

import { getListaGrupoFaturamento } from "../cliente/clienteActions";
import { AnaliseMercadoLivre } from "./abas/AnaliseMercadoLivre.jsx";
import { AnaliseContratoAluguel } from "./abas/AnaliseContratoAluguel.jsx";
import { ModalHistoricoDemandas } from "./components/ModalHistoricoDemandas.jsx";
import { ModalGestorConcessonaria } from "./components/ModalGestorConcessionaria.jsx";
import { FiltrosAnalise } from "./components/FiltrosAnalise.jsx";

const INITIAL_STATE = {
    contratosAluguel: [],
    indiceProximaAba: 0,
    exibirModalHistorico: false,
    exibirModalGestorConcessionaria: false,
    itemSelecionado: null,
    mobile: window.innerWidth < 500,
    aguardando: false,
    cores: [am4core.color("#0084ff"), am4core.color("#fdff6a"), am4core.color("#f49e13"), am4core.color("#12ffb8"), am4core.color("#ff5e76"), am4core.color("#00d5ff")],
};

function Analise(props) {
    am4core.useTheme(am4themes_dark);
    const [instanteUltimaAnalise, setInstanteUltimaAnalise] = useState(null);
    const [state, setState] = useState(INITIAL_STATE);

    useEffect(() => {
        if (!props.usuarioLogado) return;

        // 🔒 se for acesso_cliente, garante id_cliente correto
        if (props.usuarioLogado.acesso_cliente && props.filtro.id_cliente !== props.usuarioLogado.id_cliente) {
            props.setFiltro({ ...props.filtro, id_cliente: props.usuarioLogado.id_cliente });
            return; // ⛔ espera o filtro atualizar
        }

        // 🚀 só chega aqui com filtro válido
        props.getListaUnidadeConsumidora();
        props.getListaCliente();
        props.getListaDemandaContratoTipo();
        props.getListaGrupoFaturamento();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.usuarioLogado, props.filtro.id_cliente]);

    useEffect(() => {
        if (!props.filtro.id_cliente) return;

        const tab = props.tabSelecionada;

        if (tab === "empenho") props.getListaAnosEmpenho();
        if (tab === "custo") props.getListaGraficoCustoAnual();
        if (tab === "consumo") props.getListaGraficoConsumoAnual();
        if (tab === "devolucao") props.getListaGraficoValorDevolvidoAnual();
        if (tab === "multas") props.getListaGraficoCustoMultaAnual();
        if (tab === "reativo") props.getListaGraficoCustoReativoAnual();
        if (tab === "mercadoLivre") props.getListaAnaliseCativoMercadoLivreMensal();
        if (tab === "contratoAluguel") {
            props.getListaGeradorasContratosAluguelHistorico();
            props.getListaContratosAluguelHistorico();
        }
    }, [props.filtro.id_cliente, props.tabSelecionada]);

    useEffect(() => {
        if (validarExibicaoAba(props.tabSelecionada)) return;

        // 2.1 Reinicia filtros
        props.setFiltro({
            ...props.filtro,
            id_cliente: null,
            id_unidade_consumidora: null,
            id_contrato_aluguel_historico: null,
            unidades_consumidoras: [],
            unidades_custo_anual: [],
            unidades_custo_anual_periodo_safra: [],
        });
        setState((prev) => ({ ...prev, contratosAluguel: [] }));

        // 2.2 Encontra a primeira aba válida
        let novaAba = null;
        for (let i = 0; i < props.listaAbas.length; i++) {
            if (validarExibicaoAba(props.listaAbas[i])) {
                novaAba = props.listaAbas[i];
                break;
            }
        }

        // 2.3 Troca para a primeira válida
        if (novaAba) {
            props.setTabSelecionada(novaAba);
        }

        return; // mantém a semântica original
    }, [props.tabSelecionada, props.listaAbas, props.filtro.id_cliente]);

    useEffect(() => {
        if (state.indiceProximaAba !== 0) {
            setState({ indiceProximaAba: 0 });
        }
    }, [props.tabSelecionada]);

    function listar(tabSelecionada, forcarAtualizacao = false) {
        // props.getDemanda();
        props.setTabSelecionada(tabSelecionada);
        if (!forcarAtualizacao) return;

        switch (tabSelecionada) {
            case "custo":
                setAguardando(true);
                break;
            case "consumo":
                setAguardando(true);
                break;
            case "tarifa":
                setAguardando(true);
                break;
            case "horario":
                setAguardando(true);
                props.getListaGraficoConsumoForaPonta(); //busca pra saber quantos anos exibir no filtro
                break;
            case "demanda":
                setAguardando(true);
                break;
            case "reativo":
                setAguardando(true);
                props.getListaGraficoCustoReativoAnual(); //busca pra saber quantos anos exibir no filtro
                break;
            case "periodoSafra":
                setAguardando(true);
                break;
            case "multas":
                setAguardando(true);
                props.getListaGraficoCustoMultaAnual(); //busca pra saber quantos anos exibir no filtro
                break;
            case "excedente":
                setAguardando(true);
                break;
            case "empenho":
                setAguardando(true);
                break;
            case "devolucao":
                setAguardando(true);
                props.getListaGraficoValorDevolvidoAnual(); //busca pra saber quantos anos exibir no filtro
                break;
            case "mercadoLivre":
                setAguardando(true);
                props.getListaAnaliseCativoMercadoLivreMensal();
                break;
            case "contratoAluguel":
                setAguardando(true);
                props.getListaGeradorasContratosAluguelHistorico();
                props.getListaContratosAluguelHistorico();
                break;
            default:
                break;
        }
    }

    function setAguardando(valor) {
        setState({ ...state, aguardando: valor });
    }

    function buscarPropriedadeUcFiltrada(nomePropriedade) {
        const listaUcFiltro = props.listaUnidadeConsumidora.filter((item) => props.filtro.unidades_consumidoras.find((uc) => uc.value == item.id));
        //se não veio propriedade quer dizer que vai verificar se existe algum item no filtro
        if (!nomePropriedade) return !!listaUcFiltro.length;

        //se veio propriedade tem que encontrar algum item que possua a propriedade especificada
        const uc = listaUcFiltro.find((uc) => uc[nomePropriedade]);
        if (!uc) return;

        //se encontrar algum item retorna a propriedade
        return uc[nomePropriedade];
    }

    function validarExibicaoAba(aba) {
        //deve ter if para todas abas possíveis
        if (!props.filtro.id_cliente && !props.usuarioLogado.id_empresa) return true;
        const clienteSelecionado = props.listaCliente.find((cli) => cli.id == props.filtro.id_cliente) || {};
        const listaUCsClienteFiltro = props.listaUnidadeConsumidora.filter((item) => props.filtro.id_cliente && item.id_cliente == props.filtro.id_cliente);

        if (aba === "demanda" && props.usuarioLogado.acesso_modulo_analise_demanda) {
            return listaUCsClienteFiltro.find((item) => [1, 4].includes(parseInt(item.id_grupo_faturamento)) || item.id_grupo_faturamento == 3);
        }
        if (aba === "reativo" && props.usuarioLogado.acesso_modulo_analise_reativo) {
            return listaUCsClienteFiltro.find((item) => [1, 4].includes(parseInt(item.id_grupo_faturamento)) || item.id_grupo_faturamento == 3);
        }
        if (aba === "multas" && props.usuarioLogado.acesso_modulo_analise_multa) {
            return listaUCsClienteFiltro.find((item) => [1, 4].includes(parseInt(item.id_grupo_faturamento)) || item.id_grupo_faturamento == 3);
        }

        if (aba === "horario" && props.usuarioLogado.acesso_modulo_analise_aproveitamento_consumo_horario) {
            return listaUCsClienteFiltro.find((item) => [1, 4].includes(parseInt(item.id_grupo_faturamento)) || item.id_grupo_faturamento == 3 || item.irrigante);
        }

        if (aba === "excedente" && props.usuarioLogado.acesso_modulo_analise_micro_mini_geracao) {
            return listaUCsClienteFiltro.find((item) => item.geracao || item.remota);
        }

        // if (aba === "periodoSafra") {
        //     return listaUCsClienteFiltro.find((item) => item.id_atividade == 2) || clienteSelecionado.visualiza_analise_periodo_safra; //2 = atividade rural
        // }

        if (aba === "empenho" && props.usuarioLogado.acesso_modulo_analise_empenho) {
            return props.usuarioLogado.cliente_prefeitura || clienteSelecionado.cliente_prefeitura;
        }

        if (aba === "devolucao" && props.usuarioLogado.acesso_modulo_analise_devolucao) {
            return true; //!props.usuarioLogado.acesso_cliente;	inicialmente todos tem acesso
        }

        if (aba === "custo" && props.usuarioLogado.acesso_modulo_analise_custo) {
            return true; //!props.usuarioLogado.acesso_cliente;	inicialmente todos tem acesso
        }

        if (aba === "consumo" && props.usuarioLogado.acesso_modulo_analise_consumo) {
            return true; //!props.usuarioLogado.acesso_cliente;	inicialmente todos tem acesso
        }

        if (aba === "tarifa" && props.usuarioLogado.acesso_modulo_analise_tarifa) {
            return true; //!props.usuarioLogado.acesso_cliente;	inicialmente todos tem acesso
        }
        if (aba === "mercadoLivre" && props.usuarioLogado.acesso_modulo_analise_mercado_livre) {
            return true; //!props.usuarioLogado.acesso_cliente;	inicialmente todos tem acesso
        }
        if (aba === "contratoAluguel" && props.usuarioLogado.acesso_modulo_analise_contrato_aluguel_usina) {
            return clienteSelecionado.possui_contrato_aluguel;
        }
        if (aba === "INDEFINIDA") {
            return false;
        }
    }

    function handleChangeFiltroAno(ano) {
        const modoSafra = props.filtro[props.tabSelecionada + "_ano_safra"];
        atualizarFiltros({ ano, modoSafra });
    }

    function handleChangePeriodoVisualizacao(modoSafra) {
        const ano = props.filtro["ano_" + props.tabSelecionada];
        atualizarFiltros({ ano, modoSafra });
    }

    function atualizarFiltros({ ano, modoSafra }) {
        const dataAtual = new Date();
        const mesAtual = dataAtual.getMonth() + 1 < 10 ? "0" + (dataAtual.getMonth() + 1) : dataAtual.getMonth() + 1;
        const anoAtual = dataAtual.getFullYear();

        const safraAtual = (parseInt(ano) == anoAtual && parseInt(mesAtual) >= 6) || (parseInt(ano) + 1 == anoAtual && parseInt(mesAtual) < 6);
        const competenciaFinalSafraA = safraAtual ? (parseInt(mesAtual) >= 6 ? `${parseInt(ano) - 1}${mesAtual}` : `${ano}${mesAtual}`) : `${ano}05`;
        const competenciaFinalSafraB = safraAtual ? (parseInt(mesAtual) >= 6 ? `${ano}${mesAtual}` : `${parseInt(ano) + 1}${mesAtual}`) : `${parseInt(ano) + 1}05`;

        switch (props.tabSelecionada) {
            case "custo":
                props.setFiltro({
                    ...props.filtro,
                    ano_custo: ano,
                    custo_ano_safra: modoSafra,
                    competencia_inicial_custo: modoSafra ? `${ano}06` : `${ano}01`,
                    competencia_final_custo: modoSafra ? `${parseInt(ano) + 1}05` : `${ano}12`,
                    competencia_inicial_unidade_custo: modoSafra ? `${ano}06` : `${ano}01`,
                    competencia_final_unidade_custo: modoSafra ? `${parseInt(ano) + 1}05` : `${ano}12`,
                    competencia_inicial_custo_comparativo_antes: modoSafra ? `${parseInt(ano) - 1}06` : `${parseInt(ano) - 1}01`,
                    competencia_final_custo_comparativo_antes: modoSafra ? competenciaFinalSafraA : `${parseInt(ano) - 1}${mesAtual}`,
                    competencia_inicial_custo_comparativo_depois: modoSafra ? `${ano}06` : `${ano}01`,
                    competencia_final_custo_comparativo_depois: modoSafra ? competenciaFinalSafraB : `${ano}${mesAtual}`,
                    ano_acumulado_custo: ano,
                });
                break;
            case "consumo":
                props.setFiltro({
                    ...props.filtro,
                    ano_consumo: ano,
                    consumo_ano_safra: modoSafra,
                    competencia_inicial_consumo_comparativo_antes: modoSafra ? `${parseInt(ano) - 1}06` : `${parseInt(ano) - 1}01`,
                    competencia_final_consumo_comparativo_antes: modoSafra ? competenciaFinalSafraA : `${parseInt(ano) - 1}${mesAtual}`,
                    competencia_inicial_consumo_comparativo_depois: modoSafra ? `${ano}06` : `${ano}01`,
                    competencia_final_consumo_comparativo_depois: modoSafra ? competenciaFinalSafraB : `${ano}${mesAtual}`,
                    ano_acumulado_consumo: ano,
                });
                break;
            case "devolucao":
                //busca pra ver quantos anos vai listar no filtro
                props.getListaGraficoValorDevolvidoAnual();
                props.setFiltro({
                    ...props.filtro,
                    ano_devolucao: ano,
                    devolucao_ano_safra: modoSafra,
                    competencia_inicial_comparativo_devolucao_ressarcimento: modoSafra ? `${ano}06` : `${ano}01`,
                    competencia_final_comparativo_devolucao_ressarcimento: modoSafra ? `${parseInt(ano) + 1}05` : `${ano}12`,
                    competencia_inicial_devolucao_por_uc: modoSafra ? `${ano}06` : `${ano}01`,
                    competencia_final_devolucao_por_uc: modoSafra ? `${parseInt(ano) + 1}05` : `${ano}12`,
                });
                break;
            case "multas":
                //busca pra ver quantos anos vai listar no filtro
                props.getListaGraficoCustoMultaAnual();
                props.setFiltro({
                    ...props.filtro,
                    ano_multas: ano,
                    multas_ano_safra: modoSafra,
                    competencia_inicial_comparativo_tipo_multa: modoSafra ? `${ano}06` : `${ano}01`,
                    competencia_final_comparativo_tipo_multa: modoSafra ? `${parseInt(ano) + 1}05` : `${ano}12`,
                });
                break;
            case "reativo":
                //busca pra ver quantos anos vai listar no filtro
                props.getListaGraficoCustoReativoAnual();
                props.setFiltro({
                    ...props.filtro,
                    ano_reativo: ano,
                    reativo_ano_safra: modoSafra,
                    competencia_inicial_reativo: modoSafra ? `${ano}06` : `${ano}01`,
                    competencia_final_reativo: modoSafra ? `${parseInt(ano) + 1}05` : `${ano}12`,
                });
                break;
            case "horario":
                //busca pra ver quantos anos vai listar no filtro
                props.getListaGraficoConsumoForaPonta();
                props.setFiltro({
                    ...props.filtro,
                    ano_horario: ano,
                    horario_ano_safra: modoSafra,
                    competencia_inicial_horario: modoSafra ? `${ano}06` : `${ano}01`,
                    competencia_final_horario: modoSafra ? `${parseInt(ano) + 1}05` : `${ano}12`,
                    competencia_inicial_horario_comparativo_antes: modoSafra ? `${parseInt(ano) - 1}06` : `${parseInt(ano) - 1}01`,
                    competencia_final_horario_comparativo_antes: modoSafra ? competenciaFinalSafraA : `${parseInt(ano) - 1}${mesAtual}`,
                    competencia_inicial_horario_comparativo_depois: modoSafra ? `${ano}06` : `${ano}01`,
                    competencia_final_horario_comparativo_depois: modoSafra ? competenciaFinalSafraB : `${ano}${mesAtual}`,
                });
                break;
            default:
                break;
        }
    }

    function getListaAnos(props) {
        //busca uma lista inicial para saber quais anos tem dados para serem exibidos
        //atualmente tem 3 formas de listas para adaptar a lista de anos do select

        const listaOriginal = props["lista_grafico_" + props.tabSelecionada] || [];
        const modoSafra = props.filtro[props.tabSelecionada + "_ano_safra"];
        let nomeCampo = modoSafra ? "ano_inicio_fim_safra" : "ano";

        //se for a aba de custo o nome do campo sempre é ano, mesmo no modo safra
        if (["custo", "consumo"].includes(props.tabSelecionada)) nomeCampo = "ano";

        const lista = [];
        //percorre a listaOriginal e vai incluindo o ano na lista
        for (const item of listaOriginal) {
            let nomeLista = item.anos ? "anos" : item.itens ? "itens" : null;
            //se tem uma lista de anos percorre cada uma e adiciona os anos que ainda não foram incluidos
            if (nomeLista) {
                // {mes:01, anos:[]} ou {mes:01, itens:[]}
                for (const ano of item[nomeLista]) {
                    //add o /proxAno de forma diferente na aba de custo e consumo, pq a antes de clicar em atualizar a lista vem apenas com o ano, e não ano/ano
                    let anoFormatado = ano[nomeCampo];
                    if (modoSafra && ["custo", "consumo"].includes(props.tabSelecionada) && !String(ano[nomeCampo]).includes("/")) {
                        anoFormatado = ano[nomeCampo] + "/" + (ano[nomeCampo] + 1);
                    } else if (!modoSafra && ["custo", "consumo"].includes(props.tabSelecionada) && String(ano[nomeCampo]).includes("/")) {
                        anoFormatado = String(ano[nomeCampo]).split("/")[0];
                    }

                    if (anoFormatado && !lista.includes(String(anoFormatado))) {
                        lista.push(String(anoFormatado));
                    }
                }
            } else {
                // item :
                // {
                //     "ano" ou "ano_periodo_safra": "2019",
                //     "valor_fatura": "158535.3400",
                //     "valor": 2951.37
                // }

                if (item[nomeCampo] && !lista.includes(item[nomeCampo])) lista.push(item[nomeCampo]);
            }
        }
        //ordena a lista de anos
        lista.sort((a, b) => (modoSafra ? b.split("/")[0] - a.split("/")[0] : b - a));
        // console.log(lista);
        return (["devolucao", "multas", "reativo"].includes(props.tabSelecionada) || props.filtro.id_cliente) && lista.length
            ? lista.map((ano) => ({
                  id: modoSafra ? ano.split("/")[0] : ano,
                  valor: ano,
              }))
            : [
                  {
                      id: `${new Date().getFullYear()}`,
                      valor: modoSafra ? `${new Date().getFullYear()}/${new Date().getFullYear() + 1}` : `${new Date().getFullYear()}`,
                  },
              ];
    }

    function handleAtualizar() {
        if (props.tabSelecionada === "mercadoLivre" && props.filtro.unidades_consumidoras.length !== 1) {
            setError("Selecione apenas uma UC para a análise de mercado livre");
            return;
        }

        if (props.tabSelecionada === "excedente" && !props.filtro.id_cliente && !props.filtro.unidades_consumidoras.length) {
            setInfo("Seleciona um cliente ou alguma UC para buscar os dados");
            return;
        }

        if (props.tabSelecionada === "demanda") {
            const temHorosazonalAzulNoFiltro =
                !props.filtro.unidades_consumidoras.length ||
                props.listaUnidadeConsumidora.find((item) => props.filtro.unidades_consumidoras.find((uc) => item.id == uc.value && item.id_modalidade_tarifaria == 2));

            const contratoDemandaPontaNoFiltro = props.filtro.id_tipo_contrato_demanda == 2;
            if (!temHorosazonalAzulNoFiltro && contratoDemandaPontaNoFiltro) {
                setError("Unidades da modalidade Horosazonal Verde não possuem Contrato de Demanda Ponta");
            }
            const temUcsGeradorasNoFiltro =
                !props.filtro.unidades_consumidoras.length ||
                props.listaUnidadeConsumidora.find((item) => props.filtro.unidades_consumidoras.find((uc) => item.id == uc.value && item.geracao));
            const contratoDemandaGeracaoNoFiltro = props.filtro.id_tipo_contrato_demanda == 3;

            if (!temUcsGeradorasNoFiltro && contratoDemandaGeracaoNoFiltro) {
                setError("Unidades sem geração não possuem Contrato de Demanda Geração");
            }
        }

        listar(props.tabSelecionada, true);
        setInstanteUltimaAnalise(new Date().getTime());
    }

    if (props.pdf) {
        return <DisplayPDF closePdf={() => props.setArquivoPDF()} pdfBase64={props.pdf} nomePdf={props.nomePdf} />;
    }

    return (
        <div>
            {state.aguardando || props.aguardando ? <Loading /> : null}
            <ModalHistoricoDemandas
                contratoDemanda={props.contratoDemanda}
                visible={state.exibirModalHistorico && state.itemSelecionado && !props.pdf}
                handleClose={() => setState({ ...state, exibirModalHistorico: false, itemSelecionado: null })}
            />
            <ModalGestorConcessonaria
                visible={state.exibirModalGestorConcessionaria && state.itemSelecionado && state.itemSelecionado.gestor_concessionaria_energia && !props.pdf}
                itemSelecionado={state.itemSelecionado}
                handleClose={() => setState({ ...state, exibirModalGestorConcessionaria: false, itemSelecionado: null })}
            />

            <Content>
                <Abas
                    setFiltro={props.setFiltro}
                    filtro={props.filtro}
                    validarExibicaoAba={(aba) => validarExibicaoAba(aba)}
                    listar={(tabSelecionada, forcarAtualizacao) => listar(tabSelecionada, forcarAtualizacao)}
                    tabSelecionada={props.tabSelecionada}
                    usuarioLogado={props.usuarioLogado}
                />

                <FiltrosAnalise
                    atualizarState={(novoState) => setState((prevState) => ({ ...prevState, ...novoState }))}
                    contratosAluguel={state.contratosAluguel}
                    handleChangeFiltroAno={handleChangeFiltroAno}
                    handleChangePeriodoVisualizacao={(arg) => handleChangePeriodoVisualizacao(arg)}
                    handleAtualizar={handleAtualizar}
                />
                <AnaliseCusto
                    visible={props.tabSelecionada === "custo" && props.usuarioLogado.acesso_modulo_analise_custo}
                    state={state}
                    instanteUltimaAnalise={instanteUltimaAnalise}
                    listaAnos={getListaAnos(props)}
                    setAguardando={setAguardando}
                    listar={() => listar(props.tabSelecionada, true)}
                />
                <AnaliseConsumo
                    visible={props.tabSelecionada === "consumo" && props.usuarioLogado.acesso_modulo_analise_consumo}
                    state={state}
                    listaAnos={getListaAnos(props)}
                    setAguardando={setAguardando}
                    listar={() => listar(props.tabSelecionada, true)}
                />
                <AnaliseTarifa
                    visible={props.tabSelecionada === "tarifa" && props.usuarioLogado.acesso_modulo_analise_tarifa}
                    state={state}
                    setAguardando={setAguardando}
                    listar={() => listar(props.tabSelecionada, true)}
                    setFiltro={props.setFiltro}
                    filtro={props.filtro}
                    buscarPropriedadeUcFiltrada={buscarPropriedadeUcFiltrada}
                />
                <AnaliseAproveitamentoConsumoHorario
                    visible={props.tabSelecionada === "horario" && props.usuarioLogado.acesso_modulo_analise_aproveitamento_consumo_horario}
                    buscarPropriedadeUcFiltrada={buscarPropriedadeUcFiltrada}
                    state={state}
                    setAguardando={setAguardando}
                    listar={() => listar(props.tabSelecionada, true)}
                />
                <AnaliseDemanda
                    visible={props.tabSelecionada === "demanda" && props.usuarioLogado.acesso_modulo_analise_demanda}
                    buscarPropriedadeUcFiltrada={buscarPropriedadeUcFiltrada}
                    state={state}
                    setAguardando={setAguardando}
                />
                <AnaliseReativo
                    visible={props.tabSelecionada === "reativo" && props.usuarioLogado.acesso_modulo_analise_reativo}
                    state={state}
                    setAguardando={setAguardando}
                    listar={() => listar(props.tabSelecionada, true)}
                />
                <AnaliseMulta
                    visible={props.tabSelecionada === "multas" && props.usuarioLogado.acesso_modulo_analise_multa}
                    state={state}
                    setAguardando={setAguardando}
                    listar={() => listar(props.tabSelecionada, true)}
                />
                <AnaliseMicroMiniGeracao
                    visible={props.tabSelecionada === "excedente" && props.usuarioLogado.acesso_modulo_analise_micro_mini_geracao}
                    state={state}
                    setAguardando={setAguardando}
                    listar={() => listar(props.tabSelecionada, true)}
                    buscarPropriedadeUcFiltrada={buscarPropriedadeUcFiltrada}
                />
                <AnaliseGestaoEmpenho
                    visible={props.tabSelecionada === "empenho" && props.usuarioLogado.acesso_modulo_analise_empenho}
                    state={state}
                    listaAnos={getListaAnos(props)}
                    setAguardando={setAguardando}
                />
                <AnaliseDevolucaoRessarcimento
                    visible={props.tabSelecionada === "devolucao" && props.usuarioLogado.acesso_modulo_analise_devolucao}
                    state={state}
                    setAguardando={setAguardando}
                />
                <AnaliseMercadoLivre
                    visible={props.tabSelecionada === "mercadoLivre" && props.usuarioLogado.acesso_modulo_analise_mercado_livre}
                    state={state}
                    setAguardando={setAguardando}
                />
                <AnaliseContratoAluguel
                    visible={props.tabSelecionada === "contratoAluguel" && props.usuarioLogado.acesso_modulo_analise_contrato_aluguel_usina}
                    state={state}
                    setAguardando={setAguardando}
                />
            </Content>
        </div>
    );
}

const mapStateToProps = (state) => ({
    sessao: state.auth.usuario,
    usuarioLogado: state.auth.usuarioLogado,
    pdf: state.displayPDF.pdf,
    nomePdf: state.displayPDF.nomePdf,
    abas: state.analise.abas,
    filtro: state.analise.filtro,
    modoTela: state.analise.modoTela,
    aguardando: state.analise.aguardando,
    listaCliente: state.analise.listaCliente,
    listaDemandaContratoTipo: state.analise.listaDemandaContratoTipo,
    listaAnosEmpenho: state.analise.listaAnosEmpenho,
    tabSelecionada: state.analise.tabSelecionada,
    contratoDemanda: state.analise.contratoDemanda,
    listaAbas: state.analise.listaAbas,
    listaUnidadeConsumidora: state.analise.listaUnidadeConsumidora,
    lista_grafico_custo: state.analise.listaGraficoCustoAnual, //no select de ano usa a lista conforme a aba selecionada
    lista_grafico_consumo: state.analise.listaGraficoConsumoAnual, //no select de ano usa a lista conforme a aba selecionada
    lista_grafico_devolucao: state.analise.listaGraficoValorDevolvidoAnual, //no select de ano usa a lista conforme a aba selecionada
    lista_grafico_multas: state.analise.listaGraficoCustoMulta, //no select de ano usa a lista conforme a aba selecionada
    lista_grafico_reativo: state.analise.listaGraficoCustoReativoAnual, //no select de ano usa a lista conforme a aba selecionada
    lista_grafico_horario: state.analise.listaGraficoConsumoForaPonta, //no select de ano usa a lista conforme a aba selecionada
    listaGrupoFaturamento: state.cliente.listaGrupoFaturamento,
    listaContratoAluguelHistorico: state.analise.listaContratoAluguelHistorico,
    listaGeradorasContratoAluguelHistorico: state.analise.listaGeradorasContratoAluguelHistorico,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setFiltro,
            getListaCliente,
            getListaUnidadeConsumidora,
            getListaAnosEmpenho,
            setArquivoPDF,
            setTabSelecionada,
            getListaGrupoFaturamento,
            getListaGraficoCustoAnual,
            getListaGraficoConsumoAnual,
            getListaDemandaContratoTipo,
            getListaGraficoValorDevolvidoAnual,
            getListaGraficoCustoMultaAnual,
            getListaGraficoCustoReativoAnual,
            getListaGraficoConsumoForaPonta,
            getListaAnaliseCativoMercadoLivreMensal,
            getListaContratosAluguelHistorico,
            getListaGeradorasContratosAluguelHistorico,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(Analise);
